import React from 'react';
import type { FormErrors, FormValues, UpdateDiscoveryField } from '../data/discoveryForm';
import { Field, fieldClassName, FormSection, inputClassName, Select } from './DiscoveryFormControls';
type DiscoveryPeopleContextProps = {
  values: FormValues;
  errors: FormErrors;
  updateField: UpdateDiscoveryField;
};
export function DiscoveryPeopleContext({
  values,
  errors,
  updateField
}: DiscoveryPeopleContextProps) {
  return <FormSection number="04" title="People and context" description="The operating context keeps the recommendation grounded." data-id="element-75" data-mp="32tje1xd19gq7">
      <Field label="Teams and stakeholders involved" field="stakeholders" helper="Who will use, own, approve, or be affected by this work?" required error={errors.stakeholders} data-id="element-76" data-mp="2t1ne0grdzgjc">
        <textarea id="stakeholders" name="stakeholders" rows={3} placeholder="e.g. sales, marketing, customer success, finance, operations" value={values.stakeholders} onChange={event => updateField('stakeholders', event.target.value)} className={fieldClassName(Boolean(errors.stakeholders))} aria-invalid={Boolean(errors.stakeholders)} aria-describedby={errors.stakeholders ? 'stakeholders-error' : undefined} data-id="element-77" data-mp="2k0fiu7k62vth" />
      </Field>
      <div className="mt-5" data-id="element-78" data-mp="2wbg2pkdwwghu">
        <Field label="Budget range" field="budget" helper="Optional. A range helps propose a proportionate approach." data-id="element-79" data-mp="2wb6arr9b3z9i">
          <Select id="budget" name="budget" value={values.budget} onChange={event => updateField('budget', event.target.value)} data-id="element-80" data-mp="30aow2o51iccv">
            <option value="" data-id="element-81" data-mp="2re687qbo1en5">Prefer not to say</option>
            <option data-id="element-82" data-mp="1ax1wowx0zqz7">Under £2,500</option>
            <option data-id="element-83" data-mp="1b067we8wrmzd">£2,500–£5,000</option>
            <option data-id="element-84" data-mp="1fxg7untxbh1g">£5,000–£10,000</option>
            <option data-id="element-85" data-mp="1fyhl8yyewfmc">£10,000+</option>
            <option data-id="element-86" data-mp="vutrnhaad1uw">Still defining scope</option>
          </Select>
        </Field>
      </div>
      <div className="mt-5" data-id="element-87" data-mp="rtgpbh6ejgsq">
        <Field label="Anything else worth knowing?" field="additionalContext" helper="Optional. Links, constraints, past attempts, or specific questions are all useful." data-id="element-88" data-mp="rt8b9lyjm5fy">
          <textarea id="additionalContext" name="additionalContext" rows={4} value={values.additionalContext} onChange={event => updateField('additionalContext', event.target.value)} className={inputClassName} data-id="element-89" data-mp="i2vqbsmtga9a" />
        </Field>
      </div>
    </FormSection>;
}